module.exports = __webpack_public_path__ + "static/media/vf_mdressshoes_core.bf2ed24a.svg";